<template>
  <div class="exception">
    <div class="imgBlock">
      <div class="imgEle" :style="{ backgroundImage: `url(${img || config[type].img})` }" />
    </div>
    <div class="content">
      <h1>{{ title || config[type].title }}</h1>
      <div class="desc" v-html="desc" v-if="desc" />
      <div class="desc" v-else>{{ config[type].desc }}</div>
      <div class="actions">
        <slot v-if="$slots.actions" name="actions" />
        <router-link v-else to="/">
          <el-button>返回首页</el-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./typeConfig";

export default {
  props: {
    type: {
      type: String,
      default: "404",
    },
    title: String,
    desc: String,
    img: String,
  },
  data() {
    return {
      config,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
